<template>
  <li class="side-menu-list__item" v-if="basket">
    <a href="#" class="side-menu-list__icon" :class="icon" v-on:click.prevent="toggle">
      <div class="basket-total"  v-if="!active">{{basket.ItemsCount}}</div>
      <sidebar-basket-loader></sidebar-basket-loader>
    </a>
    <div class="sidebar" v-if="active">
      <div class="sidebar__block">
        <p class="sidebar__title">{{getResource('CurrentBasketSize')}}:</p>
        <p class="sidebar__value">{{basket.BasketSizeText}}</p>
      </div>
      <div class="sidebar__block">
        <p class="sidebar__title">{{getResource('CurrentBasketProducts')}}:</p>
        <p class="sidebar__value">{{basket.BrochuresCount}} Brochures</p>
        <p class="sidebar__value">{{basket.ImagesCount}} Images</p>
        <p class="sidebar__value">{{basket.DocumentsCount}} Documents</p>
      </div>
      <button class="button" @click="openBasket">{{getResource('OpenBasket')}}</button>
    </div>
    <div v-if="active" class="side-menu-closer" v-on:click.prevent="toggle">
    </div>
  </li>
</template>

<script>
  import { getBasketPartial } from "../../../views/basket/BasketActions";
  import { getResource } from "../../../vuex/helpers";
  import SidebarBasketLoader from "./SidebarBasketLoader";
  export default {
    vuex: {
      getters: {
        scroll: state => state.scrolled,
        menuItem: state => state.menuItem,
        basket: state => state.basketPartial,
        sidebarActive: state => state.sidebarActive
      },
      actions: {
        getBasketPartial, getResource
      }
    },

    components: { SidebarBasketLoader },

    ready: function () {
      this.getBasketPartial();
    },

    computed: {
      active () {
        return this.menuItem === this._uid;
      },
      icon () {
        var icon = (this.$route.path === "/" && !this.scroll) ? "icon-basket-white" : "icon-basket";
        icon += (this.sidebarActive && !this.active) ? " icon--disabled" : "";
        return icon;
      }
    },
    methods: {
      toggle () {
        this.$dispatch("submenu_clicked", this._uid, true);
      },

      openBasket () {
        this.$router.go("/basket");
        this.toggle();
      }
    }
  };
</script>

<style lang="scss">
  @import '../../../assets/scss/variables.scss';
  @import '../../../assets/scss/mixins.scss';

  .basket-total{
    position: absolute;
    bottom: -35px;
    font-size: 13px;
    left: 3px;
    background: $green;
    border-radius: 20px;
    display: block;
    width: 28px;
    height: 28px;
    padding-top: 7px;
    box-sizing: border-box;
    text-align: center;
    color: $green_dark;
  }

</style>



// WEBPACK FOOTER //
// SidebarBasket.vue?2635c792